import { useIsElementBlocked } from 'entities/profile';
import type { ContractorCampaignModel } from 'entities/campaign';
import { MutatableSwitcher, getRunCampaignError } from 'shared/ui/Switcher';
import { Tooltip } from 'shared/ui/Tooltip';
import { BLOCKING_MESSAGE, useUpdateCampaign } from 'entities/campaign';

const getSwitcherName = (id: number) => `campaign(${id}).isActive`;

export function RunCampaignCell({ id, isActive }: ContractorCampaignModel) {
  const isBlockingTime = useIsElementBlocked('toggle');

  return (
    <td className="text-center">
      <Tooltip
        isDisabled={!isBlockingTime}
        placement="bottom-end"
        content={BLOCKING_MESSAGE}
      >
        <MutatableSwitcher
          isDisabled={isBlockingTime}
          useUpdate={() => useUpdateCampaign(id)}
          buildMutateArgs={(isActive) => ({ payload: { isActive } })}
          getErrorMessage={getRunCampaignError}
          name={getSwitcherName(id)}
          isChecked={isActive}
        />
      </Tooltip>
    </td>
  );
}
